var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('Appointments')))]),_vm._v(" "),(_vm.userStore.role == 'customer')?_c('customer-calendar'):(_vm.userStore.role == 'trainer')?_c('trainer-calendar'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77884192","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/calendars/Calendar.vue
// module id = null
// module chunks = 